import styled from "styled-components";

const ListMenu = styled.div`
  > a > div {
    border-bottom: thin solid ${p => p.theme.color.secondary};
  }
`;

export default ListMenu;
